import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import App from "./App.js";
import { AuthProvider } from "./context/AuthContext.js";
import { ContentProvider } from "./context/ContentContext.js";
import { isSupabaseConfigured } from "./lib/supabase.js";
import { SetupRequired } from "./pages/SetupRequired.js";
import "./index.css";

const container = document.getElementById("root");

if (!container) {
  throw new Error('Missing <div id="root"> in index.html.');
}

createRoot(container).render(
  <StrictMode>
    {isSupabaseConfigured ? (
      <BrowserRouter>
        <AuthProvider>
          {/*
            Inside AuthProvider: an editable block decides whether to draw its
            pencil from the caller's role, so the content layer needs auth to
            already be in scope.
          */}
          <ContentProvider>
            <App />
          </ContentProvider>
        </AuthProvider>
      </BrowserRouter>
    ) : (
      <SetupRequired />
    )}
  </StrictMode>,
);
